import React, { FC, useState } from 'react';
import { useTranslate } from 'react-admin';

import Drawer from '~/components/Drawer';
import AccountExternalLinkForm from './AccountExternalLinkForm';
import CreateButton from '../CreateButton';
import CreateForm from '~/components/ra/CreateForm';
import { useClearAccountExternalLinksCache } from '~/hooks/accountExternalLinks';
import { FormDataConsumer } from 'react-admin';

const label = (key: string): string => `components.AccountExternalLinks.${key}`;

interface CreateActionProps {
  profileType: string;
  profileId: string;
  accountId: string;
}

const CreateAction: FC<CreateActionProps> = ({ profileType, profileId, accountId }) => {
  const translate = useTranslate();
  const t = (key: string): string => translate(label(key));
  const clearExternalAccountLinksCache = useClearAccountExternalLinksCache(accountId);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <CreateButton onClick={handleOpen} variant='add' />
      <Drawer heading={t('createDrawerTitle')} open={open} onClose={handleClose}>
        <CreateForm
          resource='externalAccountLinks'
          onSuccess={() => {
            handleClose();
            clearExternalAccountLinksCache();
          }}
        >
          <FormDataConsumer>
            {({ formData }: any) => {
              return (
                <AccountExternalLinkForm
                  profileType={profileType}
                  profileId={profileId}
                  accountId={accountId}
                  formData={formData}
                />
              );
            }}
          </FormDataConsumer>
        </CreateForm>
      </Drawer>
    </>
  );
};

export default CreateAction;
